import { jwtDecode } from 'jwt-decode';
import moment from 'moment';
import 'moment/locale/ko';
import { BASE_URL } from '../shared/constants/app';
export const getImageSrc = (folderName, imageName) => {
    if (!imageName) return;
    return `${BASE_URL}/${folderName}/${imageName}`;
};

// function lấy values và lưu vào array với format: name: [value]
export const getCheckBoxValues = (checkedValues, name, value, checked) => {
    let updatedValues = [...(checkedValues[name] || [])];

    updatedValues = checked ? [...updatedValues, value] : updatedValues.filter((val) => val !== value);

    const newCheckedValues = { ...checkedValues };
    if (updatedValues.length === 0) {
        delete newCheckedValues[name];
    } else {
        newCheckedValues[name] = updatedValues;
    }

    return newCheckedValues;
};

export const getRadioBoxValue = (checkedValues, name, value, checked) => {
    const newCheckedValues = { ...checkedValues };

    if (checked) {
        newCheckedValues[name] = [value];
    } else {
        delete newCheckedValues[name];
    }

    return newCheckedValues;
};

export const getDropdownValue = (checkedValues, name, selectedValue) => {
    const newCheckedValues = { ...checkedValues };

    if (selectedValue) {
        newCheckedValues[name] = [selectedValue];
    } else {
        delete newCheckedValues[name];
    }

    return newCheckedValues;
};

export const getDateTimeValue = (checkedValues, name, dateTimeValue) => {
    const newCheckedValues = { ...checkedValues };

    if (dateTimeValue) {
        // Định dạng giá trị ngày giờ bằng Moment.js
        const formattedValue = moment(dateTimeValue).format('YYYY-MM-DD');
        newCheckedValues[name] = formattedValue; // Lưu giá trị định dạng đầy đủ
    } else {
        delete newCheckedValues[name]; // Xóa key nếu không có giá trị
    }

    return newCheckedValues;
};

export const getSubwayClass = (key) => {
    const listData = [
        { key: '101', value: '1호선' },
        { key: '102', value: '2호선' },
        { key: '103', value: '3호선' },
        { key: '104', value: '4호선' },
        { key: '105', value: '5호선' },
        { key: '106', value: '6호선' },
        { key: '107', value: '7호선' },
        { key: '108', value: '8호선' },
        { key: '109', value: '9호선' },
        { key: '10A', value: '분당선' },
        { key: '10B', value: '공항선' },
        { key: '10C', value: '중앙선' },
        { key: '10D', value: '경의중앙선' },
        { key: '10E', value: '경춘선' },
        { key: '10F', value: '신분당선' },
        { key: '10G', value: '수인선' },
        { key: '10H', value: '의정부경전철' },
        { key: '10I', value: '에버라인' },
        { key: '10J', value: '경강선' },
        { key: '10K', value: '우이신설경전철' },
        { key: '10L', value: '서해선' },
        { key: '10M', value: '김포골드' },
        { key: '201', value: '부산1호선' },
        { key: '202', value: '부산2호선' },
        { key: '203', value: '부산3호선' },
        { key: '204', value: '부산4호선' },
        { key: '205', value: '부산김해경전철' },
        { key: '301', value: '인천1호선' },
        { key: '302', value: '인천2호선' },
        { key: '401', value: '대구1호선' },
        { key: '402', value: '대구2호선' },
        { key: '403', value: '대구3호선' },
        { key: '501', value: '광주1호선' },
        { key: '502', value: '광주2호선' },
    ];
    const match = listData.find((item) => item.value === key);

    if (match) {
        return `subway-${match.key}`;
    }

    return 'subway-df';
};

export const hideName = (name) => {
    if (name && name.length > 1) {
        const firstChar = name.charAt(0);
        const formattedName = firstChar + 'OO';
        return formattedName;
    }
    return name;
};

export const formatNumberWithCommas = (number) => {
    if (number == null) return '';
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

export const formatDate = (date) => (date ? moment(date).locale('ko').format('YY.MM.DD') : '');

export const formatDateTextKo = (date) => {
    if (!date) return '';
    return moment(date).format('YYYY년 MM월 DD일');
};
export const formatDateTime = (dateTime) => (dateTime ? moment(dateTime).locale('ko').format('YY.MM.DD HH:mm:ss') : '');

export const decodeHTMLEntities_backup = (text) => {
    // if (!text || typeof text !== 'string') return '';

    // const parser = new DOMParser();
    // const doc = parser.parseFromString(text, 'text/html');
    // let decodedText = doc.documentElement.textContent;
    // decodedText = decodedText.replace(/&amp;nbsp;/g, ' ');
    // decodedText = decodedText.replace(/nbsp/g, ' ');
    // decodedText = decodedText.replace(/& ;/g, ' ');
    // decodedText = decodedText.replace(/comma/g, ',');
    // return decodedText;
    if (!text || typeof text !== 'string') return '';

    const parser = new DOMParser();
    const doc = parser.parseFromString(text, 'text/html');
    let decodedText = doc.documentElement.innerHTML;
    decodedText = decodedText.replace(/&amp;nbsp;/g, ' ');
    decodedText = decodedText.replace(/&amp;/g, ' ');
    decodedText = decodedText.replace(/nbsp/g, ' ');
    decodedText = decodedText.replace(/& ;/g, ' ');
    decodedText = decodedText.replace(/comma/g, ',');

    const docProcessed = parser.parseFromString(decodedText, 'text/html');

    return docProcessed.body.innerHTML;
};

export const decodeHTMLEntities = (html) => {
    if (!html || typeof html !== 'string') return '';

    const textarea = document.createElement('textarea');
    textarea.innerHTML = html;
    return textarea.value.replace(/comma/g, ',');
};

export const fixInvalidNbspInTag = (html) => {
    return html.replace(/<(\w+)&nbsp;/g, '<$1 ');
};


export const handlePrint = (printRef, removeItem) => {
    if (!printRef.current) return;

    const printContent = printRef.current;
    const clonedContent = printContent.cloneNode(true);

    if (Array.isArray(removeItem)) {
        removeItem.forEach((selector) => {
            const elements = clonedContent.querySelectorAll(selector);
            elements.forEach((element) => {
                element.remove();
            });
        });
    }

    const printWindow = window.open('', '_blank', 'width=1200,height=650');
    const printDocument = printWindow.document;
    printDocument.open();
    printDocument.write(
        `<!DOCTYPE html><html lang="ko"><head><meta charset="UTF-8"><meta property="og:site_name" content="덴탈잡"><meta property="og:title" content="덴탈잡 - 대한민국 치과계 NO.1 구인구직 사이트"><meta name="msvalidate.01" content="F9D6F2552BF35978D038CF667F151525" /><meta name="viewport" content="width=device-width,initial-scale=1"><meta name="keywords" content="덴탈잡,치과계구인구직,신흥,dentaljob,치과계대표,전문취업정보"><meta name="description" content="덴탈잡 홈페이지"><title>덴탈잡 - 대한민국 치과계 NO.1 구인구직 사이트 DentalJob.co.kr</title><link rel="stylesheet" href="css/bootstrap/bootstrap.css"><link rel="stylesheet" type="text/css" charset="UTF-8" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"><link rel="stylesheet" type="text/css" href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"><link rel="stylesheet" href="css/master.css"><link rel="stylesheet" href="css/style.css"><link rel="stylesheet" href="css/animations.css"><link rel="stylesheet" href="css/print.css" media="print"><link rel="stylesheet" href="css/print.css" media="print"><script src="js/jquery-3.7.1.js"></script><script src="js/bootstrap/bootstrap.js"></script><style>@font-face{font-family:Pretendard;src:url(fonts/Pretendard/Pretendard-Light.woff2) format('woff2'),url(fonts/Pretendard/Pretendard-Light.woff) format('woff'),url(fonts/Pretendard/Pretendard-Light.ttf) format('truetype');font-weight:300;font-style:normal;font-display:swap}@font-face{font-family:Pretendard;src:url(fonts/Pretendard/Pretendard-Regular.woff2) format('woff2'),url(fonts/Pretendard/Pretendard-Regular.woff) format('woff'),url(fonts/Pretendard/Pretendard-Regular.ttf) format('truetype');font-weight:400;font-style:normal;font-display:swap}@font-face{font-family:Pretendard;src:url(fonts/Pretendard/Pretendard-Medium.woff2) format('woff2'),url(fonts/Pretendard/Pretendard-Medium.woff) format('woff'),url(fonts/Pretendard/Pretendard-Medium.ttf) format('truetype');font-weight:500;font-style:normal;font-display:swap}@font-face{font-family:Pretendard;src:url(fonts/Pretendard/Pretendard-SemiBold.woff2) format('woff2'),url(fonts/Pretendard/Pretendard-SemiBold.woff) format('woff'),url(fonts/Pretendard/Pretendard-SemiBold.ttf) format('truetype');font-weight:600;font-style:normal;font-display:swap}@font-face{font-family:Pretendard;src:url(fonts/Pretendard/Pretendard-Bold.woff2) format('woff2'),url(fonts/Pretendard/Pretendard-Bold.woff) format('woff'),url(fonts/Pretendard/Pretendard-Bold.ttf) format('truetype');font-weight:700;font-style:normal;font-display:swap}@font-face{font-family:Pretendard;src:url(fonts/Pretendard/Pretendard-ExtraBold.woff2) format('woff2'),url(fonts/Pretendard/Pretendard-ExtraBold.woff) format('woff'),url(fonts/Pretendard/Pretendard-ExtraBold.ttf) format('truetype');font-weight:800;font-style:normal;font-display:swap}@font-face{font-family:Pretendard;src:url(fonts/Pretendard/Pretendard-Black.woff2) format('woff2'),url(fonts/Pretendard/Pretendard-Black.woff) format('woff'),url(fonts/Pretendard/Pretendard-Black.ttf) format('truetype');font-weight:900;font-style:normal;font-display:swap}@font-face{font-family:'Jeju Myeongjo';src:url(fonts/JejuMyeongjo/JejuMyeongjoOTF.otf) format('opentype'),url(fonts/JejuMyeongjo/JejuMyeongjo.ttf) format('truetype');font-weight:400;font-style:normal;font-display:swap}</style></head><body>${clonedContent.innerHTML}</body></html>`,
    );
    printDocument.close();

    printWindow.focus();
    setTimeout(() => printWindow.print(), 500);
};

export const parseResumeSchoolInfo = (info) => {
    const [fromYears, fromMonths, toYears, toMonths, names, yearStudyDurations, majors, statuses, gpas, gpaScales] =
        info.split('|').map((item) => item.split(','));

    const schoolInfo = [];

    for (let i = 0; i < fromYears.length; i++) {
        schoolInfo.push({
            from: `${fromYears[i]}.${fromMonths[i]}`,
            to: `${toYears[i]}.${toMonths[i]}`,
            name: names[i],
            yearStudyDuration: yearStudyDurations[i],
            major: majors[i],
            status: statuses[i],
            gpa: gpas[i],
            gpaScale: gpaScales[i],
        });
    }

    return schoolInfo;
};

export const parseResumeCareerInfo = (info) => {
    const dataSections = (info || '').split('|');

    const fromYears = dataSections[0]?.split('###') || [];
    const fromMonths = dataSections[1]?.split('###') || [];
    const toYears = dataSections[2]?.split('###') || [];
    const toMonths = dataSections[3]?.split('###') || [];
    const businessNames = dataSections[4]?.split('###') || [];
    const locations = dataSections[5]?.split('###') || [];
    const responsibilities = dataSections[6]?.split('###') || [];
    const etcs = dataSections[7]?.split('###') || [];
    const reasonsLeave = dataSections[8]?.split('###') || [];
    const working = dataSections[9]?.split('###') || [];

    const careerInfo = [];

    for (let i = 0; i < fromYears.length; i++) {
        careerInfo.push({
            from: `${fromYears[i] || ''}.${fromMonths[i] || ''}`,
            to: `${toYears[i] || ''}.${toMonths[i] || ''}`,
            businessName: businessNames[i]?.trim() || '',
            location: locations[i]?.trim() || '',
            respon: responsibilities[i]?.trim() || '',
            etc: etcs[i]?.trim() || '',
            reasonLeave: reasonsLeave[i]?.trim() || '',
            working: working[i]?.trim() || 'N',
        });
    }

    return careerInfo;
};

export const parseResumeLicenseInfo = (info) => {
    const [years = [], months = [], names = [], agencies = [], licenseType = [], licenseNumber = []] = info
        .split('|')
        .map((item) => item.split('###'));

    const licenceInfo = [];

    for (let i = 0; i < years.length; i++) {
        licenceInfo.push({
            yearMonth: `${years[i]}.${months[i]}`,
            name: names[i],
            agency: agencies[i],
            licenseType: licenseType[i],
            licenseNumber: licenseNumber[i],
        });
    }

    return licenceInfo;
};

export const parseResumeActiveInfo = (info) => {
    const [fromYears = [], fromMonths = [], toYears = [], toMonths = [], places = [], contents = [], types = []] = info
        .split('|')
        .map((item) => item.split('###'));

    const activeInfo = [];

    for (let i = 0; i < fromYears.length; i++) {
        activeInfo.push({
            yearMonthStart: `${fromYears[i]}.${fromMonths[i]}`,
            yearMonthEnd: `${toYears[i]}.${toMonths[i]}`,
            place: places[i],
            content: contents[i],
            type: types[i],
        });
    }

    return activeInfo;
};

export const generateYearOptions = (startYear, endYear) => {
    const years = [];
    for (let year = startYear; year <= endYear; year++) {
        years.push({ id: year, option: year.toString(), value: year.toString() });
    }
    return years.reverse();
};

export const generateMonthOptions = () => {
    const months = [];
    for (let month = 1; month <= 12; month++) {
        months.push({
            option: month.toString().padStart(2, '0'),
            value: month.toString().padStart(2, '0'),
        });
    }
    return months;
};

export const generateDayOptions = () => {
    const days = [];
    for (let day = 1; day <= 31; day++) {
        days.push({ option: day.toString().padStart(2, '0'), value: day.toString().padStart(2, '0') });
    }
    return days;
};

export const createImage = (url) => {
    return new Promise((resolve, reject) => {
        const image = new Image();
        image.addEventListener('load', () => resolve(image));
        image.addEventListener('error', (error) => reject(error));
        image.setAttribute('crossOrigin', 'anonymous');
        image.src = url;
    });
};

export const getCroppedImg = async (imageSrc, pixelCrop) => {
    const image = await createImage(imageSrc);
    const canvas = document.createElement('canvas');
    canvas.id = 'idCanvas';
    const ctx = canvas.getContext('2d');

    const maxSize = Math.max(image.width, image.height);
    const safeArea = 2 * ((maxSize / 2) * Math.sqrt(2));

    canvas.width = safeArea;
    canvas.height = safeArea;

    ctx.translate(safeArea / 2, safeArea / 2);
    ctx.translate(-safeArea / 2, -safeArea / 2);
    ctx.drawImage(image, safeArea / 2 - image.width * 0.5, safeArea / 2 - image.height * 0.5);
    const data = ctx.getImageData(0, 0, safeArea, safeArea);

    canvas.width = pixelCrop.width;
    canvas.height = pixelCrop.height;

    ctx.putImageData(
        data,
        Math.round(0 - safeArea / 2 + image.width * 0.5 - pixelCrop.x),
        Math.round(0 - safeArea / 2 + image.height * 0.5 - pixelCrop.y),
    );

    return new Promise((resolve) => {
        canvas.toBlob((file) => {
            resolve({ url: URL.createObjectURL(file), file });
        }, 'image/png');
    });
};

export const decodeToken = (token) => {
    if (typeof token !== 'string') {
        return;
    }

    try {
        return jwtDecode(token);
    } catch (error) {
        console.error('Invalid token:', error);
        return null;
    }
};

export const getResultText = (result) => {
    if (!result) return '';
    switch (result) {
        case 'W':
            return '결과대기중';
        case 'P':
            return '합격';
        case 'F':
            return '불합격';
        case 'C':
            return '지원취소';
        default:
            return '';
    }
};

export const handleFocus = (field) => {
    const inputElement = document.getElementById(`${field}`) || document.querySelector(`[name="${field}"]`);
    if (inputElement) {
        inputElement.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'nearest' });
        if (['INPUT', 'SELECT', 'TEXTAREA'].includes(inputElement.tagName) || inputElement.isContentEditable) {
            inputElement.focus();
        } else {
            const focusableChild = inputElement.querySelector('input, select, textarea, [contenteditable="true"]');
            if (focusableChild) focusableChild.focus();
        }
    }
};

export const formatBizNo = (value) => {
    // Trả về chuỗi rỗng nếu đầu vào không hợp lệ (null, undefined)
    if (!value) return '';

    // 1. Chỉ giữ lại các chữ số
    const digits = value.replace(/\D/g, '');

    // 2. Lấy độ dài chuỗi số
    const len = digits.length;

    // 3. Xử lý trường hợp không có số hoặc quá ít số
    if (len === 0) {
        return '';
    }

    // 4. Áp dụng định dạng dựa trên độ dài
    if (len <= 3) {
        // Nếu chỉ có tối đa 3 số, trả về nguyên dạng
        // Ví dụ: 123 -> 123
        return digits;
    } else if (len <= 5) {
        // Nếu có 4 hoặc 5 số, thêm dấu gạch nối đầu tiên
        // Ví dụ: 12345 -> 123-45
        return `${digits.substring(0, 3)}-${digits.substring(3)}`;
    } else {
        // Nếu có 6 số trở lên, áp dụng định dạng đầy đủ
        // Chỉ lấy tối đa 10 chữ số đầu tiên
        // Ví dụ: 1234567890 -> 123-45-67890
        // Ví dụ: 1234567 -> 123-45-67
        // Ví dụ: 1234567890123 -> 123-45-67890 (bỏ các số thừa)
        return `${digits.substring(0, 3)}-${digits.substring(3, 5)}-${digits.substring(5, 10)}`;
    }
};

export const formatHomeUrl = (url) => {
    if (!url) return null;
    const trimmedUrl = url.trim();

    // nếu URL bắt đầu bằng http:// hoặc https://
    if (trimmedUrl.startsWith('http://') || trimmedUrl.startsWith('https://')) {
        return trimmedUrl;
    }

    // nếu URL có định dạng hợp lệ nhưng thiếu http:// hoặc https://
    if (/^[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(trimmedUrl)) {
        return `https://${trimmedUrl}`;
    }

    // nếu URL không hợp lệ, trả về null
    return null;
};

// Hàm getCodeName
export const getCodeName = (codes, key, codeLists) => {
    const list = codeLists[key]; // Lấy danh sách tương ứng với key
    const transformed = (codes || '')?.replace(/_/g, ', ')?.split(',');

    // Nếu không tìm thấy danh sách cho key, trả về mảng null
    if (!list) {
        return Array.isArray(transformed) ? transformed?.map(() => null) : [null];
    }
    // Đảm bảo codes là mảng, nếu không thì chuyển thành mảng
    const codeArray = Array.isArray(transformed) ? transformed : [transformed];

    // Loại bỏ khoảng trắng thừa ở đầu và cuối của từng mã
    const trimmedCodes = codeArray?.map((code) => code?.trim());
    const findCode = trimmedCodes.map((codeOrName) => {
        // Tìm theo code
        let found = list.find((item) => item.code === codeOrName);
        if (found) return found.code;
        // Tìm theo codeName
        found = list.find((item) => item.codeName === codeOrName);
        if (found) return found.code;
        // Không tìm thấy
        return '';
    });

    // Tìm codeName tương ứng cho từng mã đã được trim
    return findCode
        ?.sort((a, b) => Number(a) - Number(b))
        ?.filter((code) => code && code !== '')
        ?.map((code) => {
            const item = list?.find((item) => item?.code === code);
            return item
                ? `${item?.codeName}${code === findCode[findCode.length - 1] ? '' : ','} `
                : `${code}${code === findCode[findCode.length - 1] ? '' : ', '}`;
        });
};

export const updateMenuVisibility = (menuData, menuList) => {
    return menuList.filter((menuItem) => {
        const matchedMenu = menuData.find((item) => item.menuID === menuItem.url.replace('/', ''));
        return matchedMenu ? matchedMenu.display === 'Y' : true;
    });
};

export const shouldDisplayMenu = (menuID, menuData) => {
    const matchedMenu = menuData.find((item) => item.menuID === menuID);
    return matchedMenu ? matchedMenu.display === 'Y' : false;
};
